export const FONT_WEIGHT = {
    REGULAR: 400,
    MEDIUM: 500,
    SEMIBOLD: 600,
}
